import React, { useState, useEffect } from "react";
import { login } from "../../../utils/auth.controller";
import { useAuth } from "../../../context/AuthContext"; // Import the AuthContext to access user data
import styles from './Login.module.css';
import CreateForm from '../../Design/Forms/CreateForm'; // Import CreateForm component
import { FormFields } from '../../Design/Forms/FormJson'; // Import FormFields which contains loginFields
import BackgroundImage from '../../../assets/Background.png';
import InvisibleButton from "../../Design/Button/Invisible/Invisible";

const Login = () => {
  const { user, setUser, setIsAuthenticated } = useAuth(); // Access user data from context
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Clear input fields on component mount
  useEffect(() => {
    setFormData({
      email: '',
      password: ''
    });
  }, []);

  // Add a useEffect to handle redirect after the user data is updated
  useEffect(() => {
    if (user && user.role) {
      console.log("User data in effect:", user); // Debug log
      setSuccessMessage("Login successful! Redirecting...");
      
      // Once the user data is updated in context, redirect based on role
      setTimeout(() => {
        if (user.role === "admin") {
          window.location.href = "/admin"; // Make sure this matches your route
        } else if (user.role === "investor") {
          window.location.href = "/portal";
        } else if (user.role === "fundraiser") {
          window.location.href = "/sponsor";
        } else if (user.role === "user") {
          window.location.href = "/account";
        } else {
          window.location.href = "/verify-email"; // Default redirect if no role matched
        }
      }, 500); // Increased timeout to ensure state is fully updated
    }
  }, [user]); // This will trigger whenever the user changes (like after login)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Clear any error messages
    setSuccessMessage(""); // Clear any success messages
    setIsLoading(true);

    try {
      // Perform the login operation
      const response = await login(formData);
      console.log("Login response:", response); // Debug log

      // Make sure we're getting user data from the response
      if (!response || !response.user) {
        // If login doesn't return user data, we need to fetch it separately
        // or ensure the login function returns the proper user data
        console.error("Login successful but no user data returned");
        setErrorMessage("Login successful but unable to redirect. Please try again.");
        setIsLoading(false);
        return;
      }
      
      // Set user data in context
      setUser(response.user);
      setIsAuthenticated(true);
      
      // Show success message (redirect will happen in useEffect)
      setSuccessMessage("Login successful! Redirecting...");
    } catch (err) {
      // Log and display error
      console.error("Error during login:", err);
      setErrorMessage(err.message || "Something went wrong. Please try again later.");
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setTimeout(() => {
      window.location.href = "/forgot-password"; 
    }, 10);
  };

  return (
    <div className={styles.loginPage} style={{ backgroundImage: `url(${BackgroundImage})` }}>
    <div className={styles.loginFormContainer}>
      <div className={styles.loginForm}>
        <h2>Login</h2>
        
        {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
        {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
        
          <CreateForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            text={isLoading ? "Logging in..." : "Login"}
            fields={FormFields.loginFields}  // Pass loginFields from FormFields
          />
            <InvisibleButton
              type="button"
              onClick={handleForgotPassword}
              text="forgot password"
            />
          </div>

      </div>
    </div>
  );
};

export default Login;
